import Vue from 'vue'
import Vuex from 'vuex'
import regoSearch from './rego-search'
import common from '@/store/common'
import info from '@/store/info'
import photo from '@/store/photo-upload'
import selfServiceQualifier from './self-service-qualifier'
import authenticateSeller from './authenticate-seller'
import commonVariables from './common-variables'
import { sessionStoragePersistence } from './plugins/session-storage-persistence'
import payment from './payment'
import universalLogin from './universal-login'
// import { localStoragePersistence } from './plugins/local-storage-persistence'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        info,
        regoSearch,
        common,
        photo,
        selfServiceQualifier,
        authenticateSeller,
        commonVariables,
        payment,
        universalLogin,
    },
    plugins: [
        sessionStoragePersistence({
            reducer: (state) => {
                const { common, info, regoSearch, photo, selfServiceQualifier, authenticateSeller, commonVariables, payment,universalLogin } = state;
                return { common, info, regoSearch, photo, selfServiceQualifier, authenticateSeller, commonVariables, payment, universalLogin };
            },
            mutationFilter: ({ type }) => {
                const ignoreMutations = [
                    'setFetchTokenPromise',
                    'setUploadedImages',
                    'clearImages',
                    'setSendPhotoLater',
                    'clearSendPhotoLater',
                ]
                return !ignoreMutations.includes(type);
            },
        })
        // localStoragePersistence({
        //     reducer: (state) => {
        //         const { common, info, regoSearch, photo } = state;
        //         return { common, info, regoSearch, photo };
        //     },
        //     mutationFilter: ({ type }) => {
        //         const ignoreMutations = [
        //             'setFetchTokenPromise',
        //             'setUploadedImages',
        //             'clearImages',
        //             'setSendPhotoLater',
        //             'clearSendPhotoLater',
        //         ]
        //         return !ignoreMutations.includes(type);
        //     }
        // })
    ]
})

export default store
